import {
  getMyLeaves as getMyLeavesService,
  updateLeaveAction as updateLeaveActionService,
  getYearlyLeaveReport as getYearlyLeaveReportService,
  adjustLeaveBalance as adjustLeaveBalanceService,
} from "services/company/leaveManagement/leaveDetails/leaveDetailsService";
import {
  getLeavesStart,
  getLeavesSuccess,
  getLeavesFailure,
  updateLeaveActionStart,
  updateLeaveActionSuccess,
  updateLeaveActionFailure,
  getYearlyLeaveReportStart,
  getYearlyLeaveReportSuccess,
  getYearlyLeaveReportFailure,
} from "./leaveDetailsSlice";
import { showSuccessToast, showErrorToast } from "utils/toastNotification";

// Fetch all leaves
export const fetchMyLeaves =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch(getLeavesStart());
      const response = await getMyLeavesService(params);

      if (response?.meta?.status === true && response?.meta?.code === 200) {
        dispatch(getLeavesSuccess(response.data));
        return { success: true, data: response.data };
      } else {
        const errorMsg = response?.meta?.message || "Failed to fetch leaves";
        dispatch(getLeavesFailure(errorMsg));
        showErrorToast(errorMsg);
        return { success: false, error: errorMsg };
      }
    } catch (error) {
      console.error("Fetch leaves error:", error);
      const errorMsg =
        error?.response?.data?.meta?.message ||
        error.message ||
        "Failed to fetch leaves";
      dispatch(getLeavesFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  };

// Update leave action (approve/reject)
export const updateLeaveAction = (leaveId, actionData) => async (dispatch) => {
  try {
    dispatch(updateLeaveActionStart());
    const response = await updateLeaveActionService(leaveId, actionData);

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      // Fetch updated leaves after action
      await dispatch(fetchMyLeaves());
      dispatch(updateLeaveActionSuccess({ id: leaveId, ...actionData }));
      showSuccessToast(
        response?.meta?.message || `Leave ${actionData.action} successfully!`,
      );
      return { success: true, data: response.data };
    } else {
      const errorMsg =
        response?.meta?.message || "Failed to update leave action";
      dispatch(updateLeaveActionFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Update leave action error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to update leave action";
    dispatch(updateLeaveActionFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Fetch yearly leave report
export const fetchYearlyLeaveReport =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch(getYearlyLeaveReportStart());
      const response = await getYearlyLeaveReportService(params);

      if (response?.meta?.status === true && response?.meta?.code === 200) {
        dispatch(
          getYearlyLeaveReportSuccess({
            data: response.data,
            year: response.meta.year,
            title: response.meta.title,
            totalEmployees: response.meta.total_employees,
          }),
        );
        return { success: true, data: response.data };
      } else {
        const errorMsg =
          response?.meta?.message || "Failed to fetch yearly leave report";
        dispatch(getYearlyLeaveReportFailure(errorMsg));
        showErrorToast(errorMsg);
        return { success: false, error: errorMsg };
      }
    } catch (error) {
      console.error("Fetch yearly leave report error:", error);
      const errorMsg =
        error?.response?.data?.meta?.message ||
        error.message ||
        "Failed to fetch yearly leave report";
      dispatch(getYearlyLeaveReportFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  };

export const adjustLeaveBalance = (data) => async (dispatch) => {
  try {
    const response = await adjustLeaveBalanceService(data);

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      showSuccessToast(response?.meta?.message || "Leave balance adjusted");
      return { success: true, data: response.data };
    }

    const msg =
      response?.meta?.message || response?.message || "Failed to adjust leave";
    showErrorToast(msg);
    return { success: false, error: msg };
  } catch (error) {
    const msg =
      error?.response?.data?.meta?.message ||
      error?.response?.data?.message ||
      error?.response?.data?.errors?.[0]?.message ||
      error?.response?.data?.error ||
      error.message ||
      "Failed to adjust leave";
    showErrorToast(msg);
    return { success: false, error: msg };
  }
};
